const bcs:any = {
  branch: {sv:'branch',lb:'Branch',nm:'bri',vf:'rid',df:'nam',rf:'brn'},
  context: {sv:'context',lb:'Context',nm:'ctx',vf:'rid',df:'nam',rf:'ctx'},
  entity:{sv:'entity',lb:'Entity',nm:'eid',vf:'rid',df:'nam',rf:'enm'},
  inspectionentity:{sv:'entity',lb:'Entity',nm:'eid',vf:'rid',df:'nam',rf:'ens'},
  entitytype:{sv:'entitytype',lb:'EntityType',nm:'eti',vf:'rid',df:'nam',rf:'ety'},
  gender:{sv:'gender',lb:'Gender',nm:'gdi',vf:'rid',df:'nam',rf:'gdn'},
  loginstatus:{sv:'loginstatus',lb:'Login Status',nm:'lst',vf:'rid',df:'nam',rf:'lst'},
  loglevel:{sv:'loglevel',lb:'Log Level',nm:'lvi',vf:'rid',df:'nam',rf:'lvn'},
  role:{sv:'role',lb:'Role',nm:'roi',vf:'rid',df:'nam',rf:'rnm'},
  services:{sv:'services',lb:'Service',nm:'sri',vf:'rid',df:'nam',rf:'sna'},
  user:{sv:'user',lb:'User',nm:'usi',vf:'rid',df:'nam',rf:'unm'},

  //clearer:{sv:'clearer',lb:'Clearer',nm:'cri',vf:'rid',df:'nam',rf:'crn'},
  //client:{sv:'client',lb:'Cleint',nm:'lci',vf:'rid',df:'nam',rf:'cln'},
  configuration:{sv:'configuration',lb:'Configuration',nm:'cfi',vf:'rid',df:'nam',rf:'cfn'},
  country:{sv:'country',lb:'Country',nm:'coi',vf:'rid',df:'nam',rf:'coy'},
  currency:{sv:'currency',lb:'Currency',nm:'cui',vf:'rid',df:'nam',rf:'cur'},
  groups:{sv:'groups',lb:'Group',nm:'gci',vf:'rid',df:'nam',rf:'gnm'},
  maritalstatus:{sv:'maritalstatus',lb:'Marital Status',nm:'mrd',vf:'rid',df:'nam',rf:'mrc'},
  marriagetype:{sv:'marriagetype',lb:'Marriage Type',nm:'mti',vf:'rid',df:'nam',rf:'mtn'},
  members:{sv:'members',lb:'Member',nm:'pmi',vf:'rid',df:'nam',rf:'nam'},
  occupationalstatus:{sv:'occupationalstatus',lb:'Occupational Status',nm:'oid',vf:'rid',df:'nam',rf:'orn'},
  religiousdenomination:{sv:'religiousdenomination',lb:'Denomination',nm:'sdi',vf:'rid',df:'nam',rf:'sdn'},
  //customer:{sv:'customer',lb:'Customer',nm:'cid',vf:'rid',df:'nam',rf:'cnm'},
  dashtype:{sv:'dashtype',lb:'Dashtype',nm:'dti',vf:'rid',df:'nam',rf:'dtn'},
  district:{sv:'district',lb:'District',nm:'dsi',vf:'rid',df:'nam',rf:'dsn'},
  //fund:{sv:'fund',lb:'Fund',nm:'fui',vf:'rid',df:'nam',rf:'fun'},
  idtype:{sv:'idtype',lb:'ID Type',nm:'iti',vf:'rid',df:'nam',rf:'itn'},
  auditoriumlocation:{sv:'auditoriumlocation',lb:'Auditoriumn',nm:'lci',vf:'rid',df:'nam',rf:'lcn'},
  mass:{sv:'mass',lb:'Mass',nm:'msi',vf:'rid',df:'nam',rf:'msn'},
  announcementtype: { sv: 'announcementtype', lb: 'Type', nm: 'ati', vf: 'rid', df: 'nam', rf: 'ati' },
  membertype: { sv: 'membertype', lb: 'Member Type', nm: 'mti', vf: 'rid', df: 'nam', rf: 'mti' },
  occupation: { sv: 'occupation', lb: 'Occupation', nm: 'mti', vf: 'rid', df: 'nam', rf: 'ocd' },
  mothers: { sv: 'mothers', lb: 'Select', nm: 'mid', vf: 'rid', df: 'nam', rf: 'mid' },
  fathers: { sv: 'fathers', lb: 'Select', nm: 'fid', vf: 'rid', df: 'nam', rf: 'fid' },
  executiverole: { sv: 'executiverole', lb: 'Executive Role', nm: 'eri', vf: 'rid', df: 'nam', rf: 'eri' },
  committeetype: { sv: 'committeetype', lb: 'Committe Type', nm: 'cti', vf: 'rid', df: 'nam', rf: 'cti' },
  contributiontype: { sv: 'contributiontype', lb: 'Contribution Type', nm: 'tpi', vf: 'rid', df: 'nam', rf: 'tpi' },
  donationstatus: { sv: 'donationstatus', lb: 'Status', nm: 'dsi', vf: 'rid', df: 'nam', rf: 'dsi' },
  pledgestatus: { sv: 'pledgestatus', lb: 'Pledge Status', nm: 'psi', vf: 'rid', df: 'nam', rf: 'psi' },
  classcombo: { sv: 'classcombo', lb: 'Class', nm: 'cli', vf: 'rid', df: 'nam', rf: 'cli' },
 
  region:{sv:'region',lb:'Region',nm:'rgi',vf:'rid',df:'nam',rf:'rgn'},
  report:{sv:'report',lb:'Report',nm:'rpi',vf:'rid',df:'nam',rf:'rpn'},

  // Ernie: Pre-Filtered Combos
  agency:{sv:'agency',lb:'Entity',nm:'eni',vf:'rid',df:'nam',rf:'enm'},
  enloc:{sv:'enloc',lb:'Location',nm:'lci',vf:'rid',df:'nam',rf:'lcc'},

  // Ernie: Platform combos
  activity:{sv:'activity',lb:'Activity',nm:'aci',vf:'rid',df:'nam',rf:'acn'},
  
  activitystate:{sv:'activitystate',lb:'Activity State',nm:'asi',vf:'rid',df:'nam',rf:'asn'},
  activitytype:{sv:'activitytype',lb:'Activity Type',nm:'ati',vf:'rid',df:'nam',rf:'atn'},
  customertype:{sv:'customertype',lb:'Customer Type',nm:'cti',vf:'rid',df:'nam',rf:'ctn'},
  devicetype:{sv:'devicetype',lb:'Device Type',nm:'dti',vf:'rid',df:'nam',rf:'dtn'},
  eventstate:{sv:'eventstate',lb:'Event State',nm:'vsi',vf:'rid',df:'nam',rf:'vsn'},
  eventtype:{sv:'eventtype',lb:'Event Type',nm:'vti',vf:'rid',df:'nam',rf:'vtn'},
  notificationstate:{sv:'notificationstate',lb:'Notification State',nm:'nsi',vf:'rid',df:'nam',rf:'nsn'},
  notificationtype:{sv:'notificationtype',lb:'Notification Type',nm:'nti',vf:'rid',df:'nam',rf:'ntn'},
  requeststate:{sv:'requeststate',lb:'Request State',nm:'rsi',vf:'rid',df:'nam',rf:'rsn'},
  requesttype:{sv:'requesttype',lb:'Request Type',nm:'rti',vf:'rid',df:'nam',rf:'rtn'},
  reviewstate:{sv:'reviewstate',lb:'Review State',nm:'wsi',vf:'rid',df:'nam',rf:'wsn'},
  reviewtype:{sv:'reviewtype',lb:'Review Type',nm:'wti',vf:'rid',df:'nam',rf:'wtn'},
  monitor:{sv:'monitor',lb:'Monitor',nm:'nsi',vf:'rid',df:'nam',rf:'nsn'},
  authoriser:{sv:'monitor',lb:'Authoriser',nm:'ati',vf:'rid',df:'nam',rf:'atn'},
  issuer:{sv:'monitor',lb:'Issuer',nm:'isi',vf:'rid',df:'nam',rf:'isn'},
  monitoring:{sv:'monitoring',lb:'Monitoring',nm:'ini',vf:'rid',df:'nam',rf:'inc'},
  severity:{sv:'severity',lb:'Severity',nm:'svi',vf:'rid',df:'nam',rf:'svc'},
  violation:{sv:'violation',lb:'Violation',nm:'vii',vf:'rid',df:'nam',rf:'vic'},
  monitoringtype:{sv:'monitoringtype',lb:'Monitoring Type',nm:'iti',vf:'rid',df:'nam',rf:'itc'},
  monitoringstate:{sv:'monitoringstate',lb:'State',nm:'sti',vf:'rid',df:'nam',rf:'stc'},
  itemstate:{sv:'itemstate',lb:'State',nm:'sti',vf:'rid',df:'nam',rf:'stc'},
  directivestate:{sv:'directivestate',lb:'State',nm:'dsi',vf:'rid',df:'nam',rf:'dsc'},
  findingstate:{sv:'findingstate',lb:'State',nm:'fsi',vf:'rid',df:'nam',rf:'fsc'},
  finding:{sv:'finding',lb:'Finding',nm:'fdi',vf:'rid',df:'nam',rf:'fdt'},
  itemtype:{sv:'itemtype',lb:'Type',nm:'iti',vf:'rid',df:'nam',rf:'itc'},
  monitortype:{sv:'monitortype',lb:'Type',nm:'iti',vf:'rid',df:'nam',rf:'itc'},
  monitorrole:{sv:'monitorrole',lb:'Role',nm:'iri',vf:'rid',df:'nam',rf:'irc'},
  team:{sv:'team',lb:'Team',nm:'tid',vf:'rid',df:'nam',rf:'tsc'},
  teamrole:{sv:'teamrole',lb:'Role',nm:'rli',vf:'rid',df:'nam',rf:'rsc'},
  teammember:{sv:'teammember',lb:'Team',nm:'tmi',vf:'rid',df:'nam',rf:'tmi'},
  messagetype:{sv:'messagetype',lb:'Type',nm:'mti',vf:'rid',df:'nam',rf:'mtn'},
  messagemode:{sv:'messagemode',lb:'Mode',nm:'mmi',vf:'rid',df:'nam',rf:'mmn'},
  messagechannel:{sv:'messagechannel',lb:'Channel',nm:'mci',vf:'rid',df:'nam',rf:'mcn'},
  messagestate:{sv:'messagestate',lb:'State',nm:'msi',vf:'rid',df:'nam',rf:'msn'},
  contacttype:{sv:'contacttype',lb:'Type',nm:'cti',vf:'rid',df:'nam',rf:'ctn'},
  linker:{sv:'contact',lb:'Linker',nm:'rci',vf:'rid',df:'nam',rf:'rcn'},
  linked:{sv:'contact',lb:'Linked',nm:'dci',vf:'rid',df:'nam',rf:'dcn'},
  linktype:{sv:'linktype',lb:'Type',nm:'lti',vf:'rid',df:'nam',rf:'ltc'},
  enquirytype:{sv:'enquirytype',lb:'Type',nm:'eti',vf:'rid',df:'nam',rf:'etn'},
  enquirychannel:{sv:'enquirychannel',lb:'Channel',nm:'eci',vf:'rid',df:'nam',rf:'ecn'},
  enquirystate:{sv:'enquirystate',lb:'State',nm:'esi',vf:'rid',df:'nam',rf:'esn'},
  
  event:{sv:'event',lb:'Event',nm:'evi',vf:'rid',df:'nam',rf:'evn'},
  requirement:{sv:'requirement',lb:'Requirement',nm:'qmi',vf:'rid',df:'nam',rf:'qmn'},
  
  uidoc:{sv:'uidoc',lb:'UI Document',nm:'dci',vf:'rid',df:'nam',rf:'dcn'},
  uipage:{sv:'uipage',lb:'UI Page',nm:'pgi',vf:'rid',df:'nam',rf:'pgn'},
  uisection:{sv:'uisection',lb:'UI Section',nm:'sci',vf:'rid',df:'nam',rf:'scn'},
  uidevice:{sv:'uidevice',lb:'UI Device',nm:'dvi',vf:'rid',df:'nam',rf:'dvn'},
  uilang:{sv:'uilang',lb:'UI Language',nm:'lgi',vf:'rid',df:'nam',rf:'lgn'},
  //upload
  filegroup:{sv:'filegroup',lb:'Group',nm:'gpi',vf:'rid',df:'nam',rf:'gpn'},
};

const servicelist:any = [
  ['idv','ID Verification'],
  ['idv-poa','ID+POA Verification'],
  ['facematch','Liveness+Facematch'],
  ['facematch-id','Liveness+Facematch+ID'],
  ['facematch-id-poa','Liveness+Facematch+ID+POA'],
  ['videomatch','Videomatch'],
  ['photomatch','Photomatch'],
  ['regmatch','Regmatch']
];

const lcs:any = {
  branch: { lb: 'Branch', nm: 'bri', vf: 'rid', df: 'nam', et: 'Select', sd: [['0', 'Default']] },
  context: { lb: 'Context', nm: 'ctx', vf: 'rid', df: 'nam', et: 'Select', sd: [[1, 'Default'], [2, 'Ordering'], [4, 'Production'], [8, 'Distribution'], [16, 'Installation'], [32, 'Maintenance']] },
  credit: { lb: 'Credit', nm: 'cre', vf: 'rid', df: 'nam', et: 'Select', sd: [[1, '1 HR'], [2, '2 HRS'], [3, '3 HRS'], [4, '4 HRS'], [5, '5 HR'], [6, '6 HRS'], [7, '7 HRS'], [8, '8 HRS']] },
  country: { lb: 'Country', nm: 'coi', vf: 'rid', df: 'nam', et: 'Select', sd: [['1', 'Ghana'], ['2', 'Nigeria'], ['3', "Cote D'Ivoire"]] },
  format: { lb: 'Format', nm: 'fmt', vf: 'rid', df: 'nam', et: 'Select', sd: [['pdf', 'Portable Document(PDF)'], ['csv', 'Comma Separated(CSV)']] },
  gender: { lb: 'Gender', nm: 'gdi', vf: 'rid', df: 'nam', et: 'Select', sd: [[1, 'Male'], [0, 'Female']] },
  regstatus: { lb: 'Registration', nm: 'rst', vf: 'rid', df: 'nam', et: 'Select', sd: [[1, 'Registered'], [0, 'Unregistered']] },
  reporttype: { lb: 'Report Type', nm: 'rpt', vf: 'rid', df: 'nam', et: 'Select', sd: [['sum', 'Summary'], ['det', 'Detail']] },
  qrcodepurpose: { lb: 'Purpose', nm: 'pur', vf: 'rid', df: 'nam', rf: 'pur', et: 'Select', sd: [['mass', 'Mass'], ['church-service', 'Church Service']] },
  service: { lb: 'Service', nm: 'svc', vf: 'rid', df: 'nam', et: 'Select', sd: servicelist },
  status: { lb: 'Status', nm: 'sts', vf: 'rid', df: 'nam', et: 'Select', sd: [[1, 'Enabled'], [0, 'Disabled'], [2, 'Locked']] },
  title: { lb: 'Title', nm: 'tti', vf: 'rid', df: 'nam', et: 'Select', sd: [['Dr.', 'Dr.'], ['Mrs.', 'Mrs.'], ['Mr.', 'Mr.'], ['Miss', 'Miss',],['Father','Father'],['Sister','Sister'],['Reverend Father','Reverend Father'],['Prof','Prof']] },
  ministry: { lb: 'Ministry', nm: 'mnc', vf: 'rid', df: 'nam', et: 'Select', sd: [['ALL', 'Main Congregation'], ['YOUTH', 'Youth'], ['CHILDREN', 'Children']] },
  sector: { lb: 'Sector', nm: 'sci', vf: 'rid', df: 'nam', et: 'Select', sd: [['0', 'Default']] },
};

function basic(service:string){
  return bcs[service];
}

function local(service:string){
  return lcs[service];
}

function combo(service:string){
  return bcs[service] || lcs[service];
}

function combox(type:string,service:string){
  return {bcs,lcs}[type][service];
}

export {bcs, lcs, basic, local, combo};
export default combox;
